import React, { useState, memo } from 'react';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Necesito conocimiento previo para empezar?',
  a: 'No. El Tomo 1 está diseñado para alguien que no sabe absolutamente nada sobre electricidad. Si entendés cómo leer este texto, podés empezar el Megapack hoy.'
}, {
  q: '¿En qué formato recibo el material?',
  a: '100% PDF descargable. Accedés de forma inmediata después del pago y podés consultarlo desde el celular, tablet o computadora en cualquier momento y lugar.'
}, {
  q: '¿Funciona si soy del interior del país?',
  a: 'Sí. Todo el contenido fue diseñado respetando la normativa eléctrica argentina nacional (AEA 90364) que aplica en todo el territorio del país.'
}, {
  q: '¿Cuánto tiempo tengo acceso al material?',
  a: 'Acceso de por vida. Una vez que lo descargás, es tuyo para siempre. Sin suscripciones, sin fechas de vencimiento.'
}, {
  q: '¿En cuánto tiempo veo resultados reales?',
  a: 'Con dedicación de 30 a 60 minutos diarios, en 30 días tenés el conocimiento completo para trabajar profesionalmente. Muchos aplican los primeros conceptos en el mismo día que empiezan el Tomo 1.'
}, {
  q: '¿Puedo cobrar trabajos con este conocimiento?',
  a: 'Sí. El Tomo 5 cubre todo lo necesario para profesionalizarte: normativas, mediciones certificadas, presupuestos y gestión de clientes. El Bono 2 incluye plantillas de presupuesto listas para usar.'
}, {
  q: '¿Qué pasa si no me sirve?',
  a: 'Tenés 30 días de garantía total. Si por cualquier motivo no estás conforme, te devolvemos el 100% de tu inversión sin preguntas. Escribinos a construyeprogresoo@gmail.com.'
}, {
  q: '¿Tiene soporte ante dudas técnicas?',
  a: 'Sí. El equipo de ConstruyeProgreso™ está disponible en construyeprogresoo@gmail.com para responder consultas sobre el contenido del Megapack.'
}];
const FAQItem = memo(function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-gray-700 rounded-xl overflow-hidden bg-gray-800" data-id="element-43">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-5 py-4 text-left flex justify-between items-center focus:outline-none hover:bg-gray-750 transition-colors" data-id="element-44">
        <span className="font-bold text-white text-[14px] md:text-base pr-4" data-id="element-45">
          {question}
        </span>
        <ChevronDown className={`w-5 h-5 text-blue-500 transition-transform duration-200 flex-shrink-0 ${isOpen ? 'rotate-180' : ''}`} data-id="element-46" />
      </button>
      {isOpen && <div className="px-5 pb-4 text-gray-400 text-[13px] md:text-sm leading-relaxed border-t border-gray-700 pt-3" data-id="element-47">
          {answer}
        </div>}
    </div>;
});
export const FAQSection = memo(function FAQSection() {
  return <section className="py-16 px-4 bg-gray-900 border-t border-gray-800" data-id="element-48">
      <div className="max-w-2xl mx-auto" data-id="element-49">
        {/* Header */}
        <div className="text-center mb-10" data-id="element-50">
          <div className="inline-block bg-blue-500/20 border border-blue-500/40 text-blue-400 text-[11px] font-black uppercase tracking-widest px-4 py-1.5 rounded-full mb-4" data-id="element-51">
            💬 Preguntas frecuentes
          </div>
          <h2 className="text-[26px] md:text-4xl font-black text-white leading-tight" data-id="element-52">
            Preguntas Frecuentes sobre el{' '}
            <span className="text-blue-500" data-id="element-53">Megapack Eléctrico PRO</span>
          </h2>
        </div>

        {/* FAQs */}
        <div className="space-y-3" data-id="element-54">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.q} answer={faq.a} data-id="element-55" />)}
        </div>
      </div>
    </section>;
});